/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { IRole } from "../../models/Roles/RolesContracts"
import { IAction, IResourceType } from '../../models/Policies/PolicyContract';
import {
  GET_ROLES,
  SET_NO_ROLES,
  SET_ROLE_SEARCH_VALUE,
  SET_SELECTED_ROLE,
  SET_FILTERED_ROLES,
  GET_ROLE_OF_SUBJECT,
  RESET_ROLES,
  SET_DATA_PLATFORM_ACTIONS,
  EXPORT_ROLES_SUCCESS, EXPORT_ROLES_FAILURE, EXPORT_ROLES_REQUEST
} from './types';

export const roleReducerInitialState: {
  searchValue: string,
  roleList: IRole[],
  filteredRoles: IRole[],
  selectedRoleItem: {},
  noRoles: boolean,
  rolesOfSubject: IRole[],
  dataPlatformActions: Record<number, IAction>,
  policyResourceTypes: Record<string, IResourceType>,
  exportLoader: boolean,
  rolesExported: {}
  error: null
} = {
  searchValue: '',
  roleList: [],
  filteredRoles: [],
  selectedRoleItem: {},
  noRoles: false,
  rolesOfSubject: [],
  dataPlatformActions: {},
  policyResourceTypes: {},
  exportLoader: false,
  rolesExported: {},
  error: null
};

export const roleReducer = (state = roleReducerInitialState, action: any) => {
  switch (action.type) {
    case SET_ROLE_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.searchValue,
      }
    case GET_ROLES:
      return {
        ...state,
        roleList: action.roleList,
      }
    case SET_SELECTED_ROLE:
      return {
        ...state,
        selectedRoleItem: action.selectedRoleItem,
      }
    case SET_FILTERED_ROLES:
      return {
        ...state,
        filteredRoles: action.filteredRoles,
      }
    case SET_NO_ROLES:
      return {
        ...state,
        noRoles: action.setNoRoles,
      }
    case GET_ROLE_OF_SUBJECT:
      return {
        ...state,
        rolesOfSubject: action.getRoleOfSubject
      }
    case RESET_ROLES:
      return {
        ...state,
        roleList: [],
        filteredRoles: [],
        selectedRoleItem: {},
        rolesOfSubject: []
      }
    case SET_DATA_PLATFORM_ACTIONS:
      return {
        ...state,
        dataPlatformActions: Object.fromEntries(
          action.dataPlatformActions.map((action: IAction) => [action.id, action])
        ),
        policyResourceTypes: Object.fromEntries(
          action.policyResourceTypes.map((resourceType: IResourceType) => [resourceType.name, resourceType])
        )
      };
    case EXPORT_ROLES_REQUEST:
      return {
        ...state,
        exportLoader: true,
        error: null
      };
    case EXPORT_ROLES_SUCCESS:
      return {
        ...state,
        rolesExported: action.rolesExported,
        exportLoader: false,
        error: null
      };
    case EXPORT_ROLES_FAILURE:
      return {
        ...state,
        rolesExported: {},
        exportLoader: false,
        error: action.error
      };
    default:
      return state
  }
};